import { render } from "./ArrowCollapse.vue?vue&type=template&id=284baf60"
import script from "./ArrowCollapse.vue?vue&type=script&lang=js"
export * from "./ArrowCollapse.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__